{
    "404": "Oh nein! Wir haben das ganze Meer abgesucht und können die Seite nicht finden!",
    "appError": {
        "title": "Etwas ist schiefgelaufen.",
        "description": "Die App ist auf ein unerwartetes Problem gestoßen. Versuchen Sie, die Seite neu zu laden oder zu Ihrem Arbeitsbereich zurückzukehren. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an den Support.",
        "home": "Zurück zum Arbeitsbereich"
    }
}
